import React, { useEffect, useRef, useState } from "react";

import {
    Box,
    Divider,
    Flex,
    HStack,
    IconButton,
    Image,
    Menu,
    MenuButton,
    MenuDivider,
    MenuItem,
    MenuList,
    Text,
    useColorModeValue as mode,
    useDisclosure,
    useToast,
} from "@chakra-ui/react";

import {
    HamburgerIcon,
    CloseIcon,
} from "@chakra-ui/icons";

import { Link as ReactLink } from "react-router-dom";

import { MdOutlineFavoriteBorder } from "react-icons/md";
import { MdOutlineAdminPanelSettings } from "react-icons/md";

import { BiUserCheck, BiUser } from "react-icons/bi";
import { FcGoogle } from "react-icons/fc";

import { useDispatch, useSelector } from "react-redux";

import { googleLogout } from "@react-oauth/google";

import {
    toggleFavorites,
} from "../redux/actions/productActions";

import {
    logout,
} from "../redux/actions/userActions";

import NavLink from "./NavLink";
import LoginForm from "./LoginForm";
import SearchInput from "./SearchInput";
import MobileNav from "./MobileNav";


const Links = [
    {
        name: "Rólunk",
        route: "/rolunk",
    },
    {
        name: "Tésztáink",
        route: "/tesztaink",
    },
    {
        name: "Pályázatok",
        route: "/palyazat",
    },
    {
        name: "Kapcsolat",
        route: "/kapcsolat",
    },
];


const Header = () => {

    const {
        isOpen,
        onOpen,
        onClose,
    } = useDisclosure();

    const dispatch = useDispatch();

    const toast = useToast();

    const {
        favoritesToggled,
        products,
    } = useSelector((state) => state.product);

    const {
        userInfo,
    } = useSelector((state) => state.user);


    const [, setShowBanner] = useState(
        userInfo ? !userInfo.active : false
    );

    const [isLoginVisible, setIsLoginVisible] =
        useState(false);


    const loginRef = useRef(null);
    const formRef = useRef(null);


    useEffect(() => {

        if (userInfo && !userInfo.active) {
            setShowBanner(true);
        }

    }, [
        favoritesToggled,
        dispatch,
        userInfo,
    ]);


    const logoutHandler = () => {

        googleLogout();

        dispatch(logout());

        toast({
            description: "Kijelentkeztél.",
            status: "success",
            isClosable: true,
        });

    };


    const handleClickOutside = (event) => {

        const clickedOutsideLogin =
            loginRef.current &&
            !loginRef.current.contains(event.target);

        const clickedOutsideForm =
            !formRef.current ||
            !formRef.current.contains(event.target);


        if (
            clickedOutsideLogin &&
            clickedOutsideForm
        ) {
            setIsLoginVisible(false);
        }

    };


    useEffect(() => {

        if (isLoginVisible) {

            document.addEventListener(
                "mousedown",
                handleClickOutside
            );

        }


        return () => {

            document.removeEventListener(
                "mousedown",
                handleClickOutside
            );

        };

    }, [isLoginVisible]);


    /*
        Egységes stílus a jobb oldali ikonokhoz
    */
    const iconButtonStyle = {

        variant: "ghost",

        borderRadius: "full",

        color: mode(
            "gray.700",
            "gray.200"
        ),

        transition: "all 0.2s ease",

        _hover: {
            bg: mode(
                "red.50",
                "gray.700"
            ),
            color: "red.600",
        },

        _active: {
            bg: mode(
                "red.100",
                "gray.600"
            ),
        },

        _focus: {
            boxShadow: "none",
        },

    };


    return (

        <Box
            h={{
                base: "68px",
                md: "94px",
            }}
            position="sticky"
            top="0"
            zIndex={20}
            w="100%"

            bg={mode(
                "rgba(255,255,255,0.97)",
                "gray.900"
            )}

            borderBottom="1px solid"

            borderColor={mode(
                "gray.100",
                "gray.700"
            )}

            boxShadow="0 2px 12px rgba(0,0,0,0.04)"

            px={{
                base: 3,
                md: 6,
            }}
        >
            <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"

                h={{
                    base: "68px",
                    md: "58px",
                }}

                maxW="8xl"

                mx="auto"

                px={{
                    base: 1,
                    md: 5,
                }}
            >
                <Box
                    width={{
                        base: "45px",
                        md: "150px",
                    }}
                >

                    <Flex
                        display={{
                            base: "flex",
                            md: "none",
                        }}
                    >

                        <IconButton
                            aria-label={
                                isOpen
                                    ? "Menü bezárása"
                                    : "Menü megnyitása"
                            }

                            icon={
                                isOpen
                                    ? (
                                        <CloseIcon
                                            fontSize="13px"
                                        />
                                    )
                                    : (
                                        <HamburgerIcon
                                            fontSize="22px"
                                        />
                                    )
                            }

                            onClick={
                                isOpen
                                    ? onClose
                                    : onOpen
                            }

                            {...iconButtonStyle}
                        />


                        <MobileNav
                            Links={Links}
                            isOpen={isOpen}
                            onClose={onClose}
                        />

                    </Flex>

                </Box>
                <Box
                    as={ReactLink}
                    to="/"

                    display="flex"
                    alignItems="center"

                    gap={{
                        base: 1,
                        md: 2,
                    }}

                    textDecoration="none"

                    _hover={{
                        textDecoration: "none",
                    }}
                >

                    <Image
                        src="/images/laskoditesztalogo.png"

                        alt="Laskodi Tészta"

                        boxSize={{
                            base: "48px",
                            md: "52px",
                        }}

                        objectFit="contain"
                    />


                    <Box
                        display={{
                            base: "none",
                            md: "flex",
                        }}

                        flexDirection="column"

                        justifyContent="center"

                        lineHeight="1.05"
                    >

                        <Text
                            fontFamily="'Poppins', sans-serif"

                            fontWeight="700"

                            fontSize="md"

                            letterSpacing="1px"

                            color={mode(
                                "gray.800",
                                "white"
                            )}
                        >
                            LASKODI
                        </Text>


                        <Text
                            fontFamily="'Poppins', sans-serif"

                            fontWeight="600"

                            fontSize="10px"

                            letterSpacing="2.5px"

                            color="red.600"
							textAlign='center'
                        >
                            TÉSZTA
                        </Text>

                    </Box>

                </Box>
                <Flex
                    width={{
                        base: "auto",
                        md: "150px",
                    }}

                    alignItems="center"

                    justifyContent="flex-end"

                    gap={{
                        base: 0,
                        md: 1,
                    }}
                >
                    {userInfo ? (

                        <Menu>

                            <MenuButton
                                rounded="full"
                                cursor="pointer"
                            >

                                <HStack>

                                    {userInfo.googleImage ? (

                                        <Image
                                            borderRadius="full"

                                            boxSize={{
                                                base: "34px",
                                                md: "38px",
                                            }}

                                            src={userInfo.googleImage}

                                            referrerPolicy="no-referrer"
                                        />

                                    ) : (

                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"

                                            color={mode(
                                                "gray.700",
                                                "gray.200"
                                            )}

                                            _hover={{
                                                color: "red.600",
                                            }}

                                            transition="all 0.2s ease"
                                        >
                                            <BiUserCheck
                                                size="27px"
                                            />
                                        </Box>

                                    )}

                                </HStack>

                            </MenuButton>


                            <MenuList
                                fontFamily="'Poppins', sans-serif"

                                borderRadius="xl"

                                borderColor="gray.100"

                                boxShadow="xl"

                                py={2}
                            >

                                <HStack
                                    px={3}
                                    py={2}
                                >

                                    <Text
                                        fontSize="sm"
                                        color="gray.600"
                                    >
                                        Üdvözöljük,
                                        {" "}
                                        {userInfo.email}!
                                    </Text>


                                    {userInfo.googleId && (
                                        <FcGoogle />
                                    )}

                                </HStack>


                                <Divider />


                                <MenuItem
                                    as={ReactLink}
                                    to="/profil"
                                    fontSize="sm"
                                >
                                    Profil
                                </MenuItem>


                                <MenuItem
                                    as={ReactLink}
                                    to="/rendelesitortenet"
                                    fontSize="sm"
                                >
                                    Rendelési történet
                                </MenuItem>


                                {userInfo.isAdmin && (

                                    <>

                                        <MenuDivider />

                                        <MenuItem
                                            as={ReactLink}
                                            to="/admin"
                                            fontSize="sm"
                                        >

                                            <MdOutlineAdminPanelSettings />

                                            <Text ml={2}>
                                                Admin
                                            </Text>

                                        </MenuItem>

                                    </>

                                )}


                                <MenuDivider />


                                <MenuItem
                                    onClick={logoutHandler}
                                    fontSize="sm"
                                    color="red.600"
                                >
                                    Kijelentkezés
                                </MenuItem>

                            </MenuList>

                        </Menu>

                    ) : (

                        <Box>
                            <Box
                                display={{
                                    base: "none",
                                    md: "block",
                                }}

                                position="relative"

                                ref={loginRef}
                            >

                                <IconButton
                                    icon={
                                        <BiUser
                                            size="24px"
                                        />
                                    }

                                    onClick={() =>
                                        setIsLoginVisible(
                                            !isLoginVisible
                                        )
                                    }

                                    aria-label="Bejelentkezés"

                                    {...iconButtonStyle}
                                />


                                {isLoginVisible && (

                                    <Box
                                        position="absolute"

                                        zIndex={30}

                                        top="46px"

                                        right="0"

                                        bg={mode(
                                            "white",
                                            "gray.800"
                                        )}

                                        borderRadius="xl"

                                        border="1px solid"

                                        borderColor={mode(
                                            "gray.100",
                                            "gray.700"
                                        )}

                                        boxShadow="0 15px 40px rgba(0,0,0,0.14)"

                                        overflow="hidden"
                                    >

                                        <Box ref={formRef}>
                                            <LoginForm />
                                        </Box>

                                    </Box>

                                )}

                            </Box>
                            <Box
                                display={{
                                    base: "block",
                                    md: "none",
                                }}
                            >

                                <IconButton
                                    as={ReactLink}

                                    to="/bejelentkezes"

                                    icon={
                                        <BiUser
                                            size="23px"
                                        />
                                    }

                                    aria-label="Bejelentkezés"

                                    {...iconButtonStyle}
                                />

                            </Box>

                        </Box>

                    )}
                    <IconButton
                        as={ReactLink}

                        to="/kedvencek"

                        onClick={() =>
                            dispatch(
                                toggleFavorites(false)
                            )
                        }

                        icon={
                            <MdOutlineFavoriteBorder
                                size="23px"
                            />
                        }

                        aria-label="Kedvencek"

                        {...iconButtonStyle}
                    />
                    <SearchInput
                        products={products}
                    />

                </Flex>

            </Box>
            <Flex
                h="36px"

                alignItems="center"

                justifyContent="center"

                display={{
                    base: "none",
                    md: "flex",
                }}
            >

                <HStack
                    as="nav"

                    spacing={{
                        md: 3,
                        lg: 5,
                    }}
                >

                    {Links.map((link) => (

                        <NavLink
                            route={link.route}
                            key={link.route}
                        >

                            {link.name}

                        </NavLink>

                    ))}
                </HStack>
            </Flex>
        </Box>
    );
};


export default Header;